import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IAssignMultipleMerchantToPortfolioRequest {
  merchantId: number[];
  userId: number;
  currentRequest: any;
}

async function assignMultipleMerchantToPortfolio(data: IAssignMultipleMerchantToPortfolioRequest): Promise<any> {
  try {

    var reqToSend = {};

    if (data.currentRequest != undefined && data.currentRequest != null) {
      reqToSend = data.currentRequest;
    } else {
      reqToSend = {
        merchantIds: data.merchantId
      }
    }

    const response = await axiosInstance.post(`/Merchant/AssignMultipleMerchantToPortfolio?newUserId=${data.userId}`, reqToSend);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAssignMultipleMerchantToPortfolio() {
  return useMutation<any, Error, IAssignMultipleMerchantToPortfolioRequest>((variables) =>
    assignMultipleMerchantToPortfolio(variables)
  );
}
